import { render, staticRenderFns } from "./circle-form.vue?vue&type=template&id=3700644a&scoped=true&"
import script from "./circle-form.vue?vue&type=script&lang=js&"
export * from "./circle-form.vue?vue&type=script&lang=js&"
import style0 from "./circle-form.vue?vue&type=style&index=0&id=3700644a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3700644a",
  null
  
)

export default component.exports